// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"4d823128","297":"1cd1a76e","643":"124186cf","787":"31eecf91"}[chunkId] + ".chunk.js";
};